import * as dataTable from './data-table';
import * as databricks from './databricks';
import * as elasticsearch from './elasticsearch';
import * as mongodb from './mongodb';
import * as mysql from './mysql';
import * as postgresql from './postgresql';
import * as redis from './redis';
import * as sql_server from './sql-server';
import * as turso from './turso';

export const databaseNodes = {
  'data-table': dataTable,
  'databricks': databricks,
  'elasticsearch': elasticsearch,
  'mongodb': mongodb,
  'mysql': mysql,
  'postgresql': postgresql,
  'redis': redis,
  'MsSQL': sql_server,
  'turso': turso,
};
